import type { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const warehouseRoutes: PermissionedRouteObject[] = [
  {
    index: true,
    handle: { breadcrumb: "Warehouse Management" },
    async lazy() {
      const { WarehouseLandingPage } = await import(
        "@redotech/redo-merchant-fulfillment-app/warehouse-landing-page"
      );
      return { Component: WarehouseLandingPage };
    },
  },
  {
    path: "transfer",
    handle: { breadcrumb: "Transfer" },
    async lazy() {
      const { TransferPage } = await import(
        "@redotech/redo-merchant-fulfillment-app/transfer/transfer-page"
      );
      return { Component: TransferPage };
    },
  },
  {
    path: "transfer/items",
    handle: { breadcrumb: "Select Items" },
    async lazy() {
      const { TransferItemsPage } = await import(
        "@redotech/redo-merchant-fulfillment-app/transfer/transfer-items-page"
      );
      return { Component: TransferItemsPage };
    },
  },
];
